import {ReactElement} from "react";

const debug = {
    dev: false,
    trace: false,
    validation      : false,
    fieldValidation : false,
    componentsRegister: false,
    change: false,
    head: "&& FormManager"
};

export type FormOptions = {
    validateBeforeSubmit?    : boolean
}

export type FormConfig = {
    fields          : any
    onSubmit?       : onChangeCallback
    onFormChanged?  : onChangeCallback
    validator?      : functionBoolean
    isFormChanged?  : boolean
}

export default class FormManager {

    public fields           : any
    public initData         : any

    public onSubmit         : onChangeCallback | null
    public onFormChanged?   : onChangeCallback
    public validator        : functionBoolean | null

    public isFormValid      : boolean
    public isFormChanged    : boolean
    public isSubmitting     : boolean   = false
    public displayErrors    : boolean   = false

    public buttonSubmit     : any   = null
    private submitButtonComponent       : any | null   = null

    private _validateBeforeSubmit   : boolean   = false

    constructor(formData:FormConfig, initData:any, options:FormOptions={}) {

        this.fields     = {};
        this.initData   = initData;

        // init fields
        _.forEach(formData.fields, (field:any, name:string) => {
            this.fields[name] = this.initField(name, field);
        });

        // if true will do for validation when user clicks submit (onFormSubmit)
        this._validateBeforeSubmit  = _.get(options, 'validateBeforeSubmit', false)

        this.onSubmit       = formData.onSubmit || null
        this.onFormChanged  = formData.onFormChanged;

        // this.submitButtonComponent = null;

        this.isFormValid    = this._isFormValid();
        this.isFormChanged  = (formData.isFormChanged) ? formData.isFormChanged : false;
        // this.isSubmitting   = false;

        // this.displayErrors  = false;

        this.validator = (formData.validator) ? formData.validator : null;
    }

    // Experimental
    addField(name:string, fieldConfig:any, initValue:any) {
        this.initData[name]     = initValue
        this.fields[name]       = this.initField(name, fieldConfig);


        //?
        this.isFormValid    = this._isFormValid();
    }

    removeField(name:string) {
        delete this.initData[name]
        delete this.fields[name]

        console.log("REMOVE unregister components")

        this.unRegisterErrorComponent(name)

        //?
        this.isFormValid    = this._isFormValid();
    }
    // End

    initField(name:string, info:any) {

        const field : any = {
            label: info.label ? info.label : gd.utils.strToTitleCase(name),
            value: this.initData[name],
            type: info.type,
            isRequired: info.isRequired ? info.isRequired : false,
            validator: info.validator ? info.validator : null,
            //isValid: false,
            component: null,
            errorComponent: null,
            onUserChange: info.onUserChange ? info.onUserChange : null,
            error: null
        };

        field.isValid = this.isFieldValid(field);

        return field;
    }

    validateFields() {
        _.forEach(this.fields, field => field.isValid = this.isFieldValid(field));
        this.isFormValid = this._isFormValid();
    }

    hasField(name:string) {
        return this.fields[name];
    }

    _isFormValid() {
        let isValid : boolean = true;

        if (debug.validation) console.groupCollapsed("_isFormValid");
        if (debug.validation) console.log("._isFormValid");

        // check if all fields are valid...
        _.forEach(this.fields, function (field, name) {
            if (!field.isValid) {
                if (debug.validation) console.log("        ", name, "- NOT valid");
                isValid = false;
            } else {
                if (debug.validation) console.log("        ", name, "- valid");
            }
        });

        // run custom validator
        if (isValid && this.validator) isValid = this.validator();
        //todo ...

        if (debug.validation) console.log("._isFormValid result=", isValid);

        if (debug.validation) console.groupEnd();


        return isValid;
    }

    validateForm(options:any={}):boolean {

        if (debug.validation) console.log(".validate form");

        const oldIsFormValid = this.isFormValid;
        const newIsFormValid = this._isFormValid();

        if (debug.validation) console.log("... validate form result=", newIsFormValid," old result=",oldIsFormValid);

        if (newIsFormValid != oldIsFormValid) {
            this.isFormValid = newIsFormValid;
            if (!options || !options.silent) this.renderSubmitButton();
        }

        return newIsFormValid;

    }

    submit() {
        this.isSubmitting = true;
        if (this.buttonSubmit)
            this.buttonSubmit.setIsBusy(true);
    }

    getValue(name:string) {
        if (!this.fields[name]) {
            console.error("FormManager.getValue() Unknown field. name=", name);
            return null;
        }
        return this.fields[name].value;
    }

    setValue(name:string, newVal:any, options:any={}) {
        this.setFieldValue(name, newVal, options);
    }

    getValues() {
        const formValues : any = {}

        _.forEach(this.fields, function (field, name) {
            formValues[name] = field.value;
        });

        return formValues;
    }

    resetValues(values : any) {

        _.forEach(values,  (value:any, name:string) => {

            if (!this.fields[name]) {
                console.warn("unknow for field", name);
                return;
            }

            if (this.fields[name].value != value) {
                this.fields[name].value = value;

                this.fields[name].isValid = this.isFieldValid(this.fields[name])
            }

        })

        this.isFormValid = this._isFormValid();

        //this.isSubmitting = false;
        //this.isFormChanged = false; eto vizivalo problem when state changes and something with restValues is within render
        //this.displayErrors = false;
    }

    // if reRender false we'll update nothing
    reset(isFormChanged : boolean=false, reRender :boolean =true) {

        this.isFormValid = this._isFormValid();
        this.isSubmitting = false;
        this.isFormChanged = (isFormChanged) ? isFormChanged : false;
        this.displayErrors = false;

        if (reRender) this.renderSubmitButton();
    }

    resetSubmit() {
        this.isSubmitting = false;
        this.renderSubmitButton();
    }

    formChanged() {

        if (debug.change) console.log(debug.head, ".formChanged");

        this.isFormChanged = true;
        this.renderSubmitButton();

        if (this.onFormChanged) this.onFormChanged(this.getValues());
    }

    registerFormComponent(name:string, component:any) {
        if (debug.componentsRegister) console.log(debug.head, ".registerFormComponent", name, component);
        this.fields[name].component = component;
    }

    registerErrorComponent(name:any, component:any) {
        if (debug.componentsRegister) console.log(debug.head, ".registerErrorComponent", name, component);
        this.fields[name].errorComponent = component;
    }

    unRegisterErrorComponent(name:any) {
        if (debug.componentsRegister) console.log(debug.head, ".unRegisterErrorComponent", name);

        if (!this.fields[name]) {
            console.warn("WARNING #99d83 - no field found", name)
            return
        }

        this.fields[name].errorComponent = null;
    }

    registerSubmitButton(component:any) {
        if (debug.componentsRegister) console.log(debug.head, ".registerSubmitButton", component);
        this.submitButtonComponent = component;
    }

    _checkTrimmedEmpty(value:any) {
        return typeof value === "string" && value.trim() === '';
    }

    isFieldValid(field:any) {
        if (debug.fieldValidation) console.groupCollapsed("validateField "+field.label);

        let isValid = true;
        let error = null;

        // check if required
        if (field.isRequired) {
            switch (field.type) {
                case 'checkbox':
                    // do nothing... field vsegda tam. esli nuzno chto bi bil checked - well custom validation needed
                    break;
                case 'select':
                    if (field.value === undefined || field.value === null || this._checkTrimmedEmpty(field.value)) {
                        isValid = false;
                        error = field.label + " is required";
                    }
                    break;
                case 'input':
                    if (!field.value || this._checkTrimmedEmpty(field.value)) {
                        isValid = false;
                        error = field.label + " is required";
                    }
                    break;
                case 'file':
                    if (!field.value || this._checkTrimmedEmpty(field.value)) {
                        isValid = false;
                        error = field.label + " is required";
                    }
                    break;
                default:
                    console.error(debug.head, ".validateField - unknown type " + field.type, field);
                    break;
            }
        }

        // check custom validaton
        if (isValid && field.validator) {
            const validatorResult = field.validator.call(this, field.value, this); // added 2nd param
            if (validatorResult !== true) {
                isValid = false;
                error = validatorResult;
            }
        }

        field.error = error;

        if (debug.fieldValidation) console.log("    valid=",isValid);
        if (debug.fieldValidation) console.groupEnd();

        return isValid;

    }

    validateField(name:string, options:any={}) {

        if (debug.validation) console.log("validate field", name);

        const field = this.fields[name];

        const oldIsValid = this.fields[name].isValid;
        const oldErrorMessage = this.fields[name].error;
        const newIsValid = this.isFieldValid(field);
        const newErrorMessage = this.fields[name].error;

        if (newIsValid !== oldIsValid) {

            if (newIsValid) field.error = null; //remove validation error
            if ((!options || !options.silent) &&
                this.displayErrors && field.errorComponent)
                field.errorComponent.forceUpdate();

            field.isValid = newIsValid;
            this.validateForm(options);

        } else if (oldErrorMessage !== newErrorMessage) {
            if ((!options || !options.silent) &&
                this.displayErrors && field.errorComponent)
                field.errorComponent.forceUpdate();
        }
    }

    setFieldIsRequired(name:string, newIsRequired:boolean) {

        if (newIsRequired == this.fields[name].isRequired) return;

        this.fields[name].isRequired = newIsRequired;
        this.validateField(name);
    }

    isFieldRequired(name:string) {
        return this.fields[name].isRequired;
    }

    setFieldValue(name:string, value:any, options:any={}) {

        if (debug.change) console.log(debug.head, 'setFieldValue', name, value, options);

        this.fields[name].value = value;
        this.validateField(name, options);

        //well we can go to on form component value change and trigger related on change... for now let's not do it'
    }

    setError(name:string, errorValue:any) {
        //this.errorComponents[name].forceUpdate();
    }

    setFormFieldCustomError(fieldName:string, errorMessage:any) {

        const field = this.fields[fieldName];

        field.isValid = false;
        field.error = errorMessage;

        this.displayErrors = true;

        field.errorComponent.forceUpdate();
    }

    // this is called by form element but ay be called manually when needed to
    onFormComponentValueChange(name:string, newVal:any) {
        if (debug.dev) console.log(debug.head, "onFormComponentValueChange", name, newVal);
        const currentValue = this.getValue(name);

        if (this.getValue(name) != newVal || typeof newVal === 'object') {
            //console.log("yes... value really changed - USER ACTION");
            this.fields[name].value = newVal;

            // run onUserChange
            if (this.fields[name].onUserChange) {
                this.fields[name].onUserChange.call(this, currentValue, newVal, this, name); // last this = reference to form
            }

            this.validateField(name);

            if (!this.isFormChanged) this.formChanged();

        } else {
            if (debug.trace) console.log(debug.head, "NO - value didnt' change it's just render of form...");
        }
    }

    renderSubmitButton() {
        if (this.submitButtonComponent) this.submitButtonComponent.forceUpdate();
        else {
            if (debug.dev) console.warn(debug.head, "submitButtoncompaonent not found");
        }
    }

    onSubmitClick() {

        // sometimes we want to double check all is good I guess...
        // like with file uploads for example
        if (this._validateBeforeSubmit) {
            this.validateFields()
            this.validateForm()
        }


        if (this.isFormValid) {
            const values = this.getValues();

            this.displayErrors = false;
            this.isSubmitting = true;
            this.renderSubmitButton();

            if (this.onSubmit) {
                this.onSubmit(values)
            }


        } else {

            if (debug.validation) {
                console.log("form is not valid... we should show errors", this);
                _.forEach(this.fields, function (field, name) {
                    console.log("... ", name, field.isValid);
                });
            }
            this.displayErrors = true;

            // force all errors to render...
            _.forEach(this.fields, function (field, name) {
                if (!field.isValid && field.error && field.errorComponent) {
                    field.errorComponent.forceUpdate();
                }
            })

        }
    }


};
